module.exports = __webpack_public_path__ + "assets/img/pctmn-banner.5b939aeb.png";